
namespace RioERP.Masters {
    export class SmtpSettingsColumns {
        static columnsKey = 'Masters.SmtpSettings';
    }
}